export function mobileNav() {
    const body = $("body");
    const btnMenu = $(".menu-opener");
    const mainNav = $('.main-menu');
    const mainNavItems = mainNav.find('.menu-item-has-children');
    const arrowButton = `<button class="arrow-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99955 11.851L4.71741 6.56885L3.56836 7.7179L9.42502 13.5745L9.99955 14.149L10.5741 13.5745L16.4308 7.7179L15.2816 6.56885L9.99955 11.851Z" fill="#2A2E34" fill-opacity="0.8"/>
                            </svg>
                        </button>`;
    let activeMenuItem;

    btnMenu.on("click", function (e) {
        body.toggleClass("menu-opened");
        e.preventDefault();
    });

    mainNavItems.each((i, item) => {
        const menuList = $(item).find(' > .sub-menu');
        if (!$(item).find('.arrow').length) {
            $(arrowButton).insertBefore(menuList, null);
        }

        if (menuList.hasClass('has-dropdown')) {
            const subMenuItems = menuList.find('.item-has-dropdown');
            subMenuItems.each((i, item) => {
                const subMenuList = $(item).find(' > ul');
                if (!$(item).find('.arrow').length) {
                    $(arrowButton).insertBefore(subMenuList, null);
                }
            });
        }
    });


    $(document).on("click", ".main-menu .menu-item-has-children .arrow-button", function (e) {
        activeMenuItem = $(this).parent();
        if (!activeMenuItem.hasClass("active")) {
            if (window.innerWidth > 1200 && body.hasClass('touch')) {
                activeMenuItem.siblings().removeClass('active').find(".sub-menu").fadeOut();
                activeMenuItem.addClass("active").find(".sub-menu").fadeIn();
            }
            activeMenuItem.siblings().removeClass('active').find(".sub-menu").slideUp();
            activeMenuItem.addClass("active").find(".sub-menu").slideDown();
            if (activeMenuItem.hasClass('item-has-dropdown')) {
                activeMenuItem.siblings().removeClass('active').find(".dropdown-list").slideUp();
                activeMenuItem.addClass("active").find(".dropdown-list").slideDown();
            }
        } else {
            if (window.innerWidth > 1200 && body.hasClass('touch')) {
                activeMenuItem.removeClass("active").find(".sub-menu").fadeOut();
            }
            activeMenuItem.removeClass("active").find(".sub-menu").slideUp();
            if (activeMenuItem.hasClass('item-has-dropdown')) {
                activeMenuItem.removeClass("active").find(".dropdown-list").slideUp();
            }
        }
    });
    $(document).on("click", function (e) {
        let target = $(e.target);
        if (target.closest('.menu-item-has-children .arrow-button').length) {
            let newActiveMenuItem = target.closest('.menu-item-has-children');
            if (body.hasClass('touch') && window.innerWidth >= 1024) {
                if (newActiveMenuItem.hasClass("active")) {
                    newActiveMenuItem.siblings().removeClass('active');
                    newActiveMenuItem.addClass("active");
                    window.addEventListener('click', closeDropdown);
                }
            }
        }

    });

    function closeDropdown(e) {
        if (!mainNavItems.has(e.target).length > 0) {
            mainNavItems.removeClass('active');
            window.removeEventListener('click', closeDropdown);
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js